export function replaceUrlTokens(url: string, accountGroupId: string, groupPath: string): string {
  return url.replace('<accountGroupId>', accountGroupId).replace('<brandPath>', groupPath);
}

// some brand names have a slash in them, slashes don't play well with the router.
export function buildBrandNameForPath(brandName: string): string {
  if (!brandName) {
    return '';
  }
  return brandName.replace('/', '%2F');
}
